module.exports = __webpack_public_path__ + "static/media/illustration.168e724b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/splash-page-images/illustration.png
// module id = 346
// module chunks = 0